import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import {VENDOR_NAMES} from '@/constants/billingConstants';

const state = {
  filterData: {},
  cspList: {
    totalCount: 0,
    list: []
  },
  selectedVendor: VENDOR_NAMES.AWS,
  isCspListLoading: true,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mis-operation-status/csp-operation-status/index.js